import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import URL from "./URLs.json";

/** Firebase config **/
const appConfigs = {
  dev: {
    app: firebase.initializeApp(
      {
        apiKey: "AIzaSyAlwDq8uSZhGv7PlSzc64lN0D6b0CvGhYE",
        authDomain: "iso-web-dev.firebaseapp.com",
        databaseURL: "https://iso-web-dev.firebaseio.com",
        projectId: "iso-web-dev",
        storageBucket: "iso-web-dev.appspot.com",
        messagingSenderId: "413636498249"
      },
      "dev"
    ),
    shop: "https://iso-web-dev-shop.firebaseio.com/"
  },
  frontale: {
    app: firebase.initializeApp(
      {
        apiKey: "AIzaSyD5_l2VLMw83NC_BK0C9xoPXeLW2d4cR2g",
        authDomain: "iso-web-v1.firebaseapp.com",
        databaseURL: "https://iso-web-v1.firebaseio.com",
        projectId: "iso-web-v1",
        storageBucket: "gs://iso-web-v1.appspot.com/",
        messagingSenderId: "674381921607"
      },
      "frontale"
    ),
    shop: "https://iso-web-v1-shop.firebaseio.com/"
  },
  eftz: {
    app: firebase.initializeApp(
      {
        apiKey: "AIzaSyDxtiRr96coNhn1Sr6uB4OLf1QxyLNjn68",
        authDomain: "eftz-iso.firebaseapp.com",
        databaseURL: "https://eftz-iso.firebaseio.com",
        projectId: "eftz-iso",
        storageBucket: "eftz-iso.appspot.com",
        messagingSenderId: "914042048817"
      },
      "eftz"
    ),
    shop: "https://eftz-iso-shop.firebaseio.com/"
  },
  bravethunders: {
    app: firebase.initializeApp(
      {
        apiKey: "AIzaSyDFTETzC0FqwivvACuVpP9KyCoc2lqRP6Y",
        authDomain: "bravethunders-iso.firebaseapp.com",
        databaseURL: "https://bravethunders-iso.firebaseio.com",
        projectId: "bravethunders-iso",
        storageBucket: "bravethunders-iso.appspot.com",
        messagingSenderId: "323903869553"
      },
      "bravethunders"
    ),
    shop: "https://bravethunders-iso-shop.firebaseio.com/"
  },
  bellmare: {
    app: firebase.initializeApp(
      {
        apiKey: "AIzaSyCnJ1UonDHfFa27UwxJPBruGCZkF09IOu0",
        authDomain: "bellmare-iso.firebaseapp.com",
        databaseURL: "https://bellmare-iso.firebaseio.com",
        projectId: "bellmare-iso",
        storageBucket: "bellmare-iso.appspot.com",
        messagingSenderId: "1048032608789"
      },
      "bellmare"
    ),
    shop: "https://bellmare-iso-shop.firebaseio.com/"
  }
};

export function getFirebase(teamId) {
  const app = appConfigs[teamId].app;
  const userDB = app.database();
  const shopDBURL = appConfigs[teamId].shop;
  const shopDB = app.database(shopDBURL);

  /** API server URL **/
  let url = URL.dev.stp;
  if (process.env.NODE_ENV === "production") {
    url = URL.prod.stp;
  }
  const backendURL = url;

  return {
    app,
    userDB,
    shopDB,
    backendURL
  };
}
